<div *ngFor="let d of viewItems;" class="card w-90 mt-3 mb-3">
  <div class="card-body">
    <span *ngIf="d.document.ItemType == 'legacy'">
      <app-dialog-legacy-download [viewType]="constants.results_view_summary" [title]="d.document.DocumentTitle"
        [accessionNumber]="d.document.AccessionNumber" [microformAddress]="d.document.MicroformAddresses">
      </app-dialog-legacy-download>
    </span>

    <a *ngIf="d.document.ItemType != 'legacy'" href="{{d.document.Url}}" class="text-primary doc-title mb-2"
      target="_blank">{{d.document.DocumentTitle}}</a>
    <p *ngIf="d.document.ItemType == 'package'" class="card-text">This is a package item, it contains links to other related documents. Click on the title to view the list of documents which are a part of this package.</p>
    <p *ngIf="d.document.ItemType == 'legacy'" class="card-text">This is a Legacy Library item. A document summary is not available however you can view the properties and request a copy via the PDR using the Microform Address: <b>{{d.document.MicroformAddresses}}</b></p>
    <p *ngIf="d.document.ItemType == 'doc'" class="card-text">{{(d.document.content | slice:0:400) + '...' }}</p>
    <div class="row mt-2 mb-2">
      <div class="col-12 col-sm-4 text-start">
        <button *ngIf="d.document.ItemType == 'package'" class="btn btn-primary bs-dark" style="background-color:  #7d4f50 !important;" (click)="show(d.document);">
          <i class="fa fa-box-archive" style="color: #fff !important"></i> Package Properties
        </button>
        <button *ngIf="d.document.ItemType == 'legacy'" class="btn btn-primary bs-dark" style="background-color:  #a78c5d !important;" (click)="show(d.document);">
          <i class="fa fa-microscope" style="color: #fff !important"></i> Document Properties
        </button>
        <button *ngIf="d.document.ItemType == 'doc'" class="btn btn-primary bs-dark" style="background-color:  #425e71 !important;" (click)="show(d.document);">
          <i class="fa fa-file-lines" style="color: #fff !important"></i> Document Properties
        </button>
      </div>
      <div class="col-12 col-sm-4 mt-2 text-truncate"><b>Accession #</b> {{d.document.AccessionNumber}}</div>
      <div class="col-12 col-sm-2 mt-2" *ngIf="d.document.ItemType != 'package'"><b>Doc. Date</b> {{d.document.DocumentDate
        |date}}</div>
      <div class="col-12 col-sm-2 mt-2" *ngIf="d.document.ItemType != 'package'"><b>Date Added</b> {{d.document.DateAddedTimestamp
        |date}}</div>
      <div class="col-12 col-sm-3 mt-2" *ngIf="d.document.ItemType == 'package'"><b>Package Date</b> {{d.document.DateAddedTimestamp
        |date}}</div>
    </div>

  </div>
</div>
